import WrapperService from "@/modules/core/services/wrapper-service";

const API_URL = process.env.VUE_APP_ROOT_API + "/api/v1/sproof"

const serviceName = "Sproof-Service: ";
export default class SproofService {

  /**
   * Calls backend controller method to make a sproof signature request for a generated POA
   *
   * @param facilityID for the facility the POA document is generated for
   * @param documentPathStr for the file on the local file system
   * @param fileName of the POA pdf document
   * @param originalDocumentId internal document id of the uploaded POA document
   * @param successF
   * @param errorF
   * @returns {Promise<void>}
   */
  static async createSignatureRequestForPOA(facilityID, documentPathStr, fileName, originalDocumentId, senderEMailAddress, senderLastName, successF, errorF) {
        var params = new URLSearchParams();

        params.append("facilityID", facilityID);
        params.append("documentPathStr", documentPathStr);
        params.append("fileName", fileName);
        params.append("originalDocumentId", originalDocumentId);
        params.append("processId", "0");
        params.append("senderEMailAddress", senderEMailAddress );
        params.append("senderLastName", senderLastName);

        await WrapperService.get(API_URL + "/createDocument/poa", {params: params}, serviceName, successF, errorF);
  }

  /**
   * Service method call to controller
   * @param memberId of the document
   * @param successF
   * @param errorF
   * @returns {Promise<void>}
   */
  static async viewStatusOfSignatureRequest(memberId, successF, errorF) {
    var params = new URLSearchParams();
    params.append("memberId", memberId);

    await WrapperService.get(API_URL + "/viewStatusOfSignatureRequest",  {params: params}, serviceName, successF, errorF);
  }

  /**
   * Gets the document list from the sproof portal
   * @param successF
   * @param errorF
   * @returns {Promise<void>}
   */
  static async getAllDocument(successF, errorF) {
    await WrapperService.get(API_URL + "/getDocumentList", null, serviceName, successF, errorF);
  }

  /**
   * Delete document form sproof
   * @param memberId of the document
   * @param successF
   * @param errorF
   * @returns {Promise<void>}
   */
  static async deleteDocument(memberId, successF, errorF) {
    var params = new URLSearchParams();
    params.append("memberId", memberId);

    await WrapperService.get(API_URL + "/deleteDocument", {params: params}, serviceName, successF, errorF);
  }

  /**
   *
   * @param documentPath of the document
   * @param email of the signer
   * @param signaturePath input file path
   * @param signerName signer name
   * @param outputDocumentPathStr output file path
   * @param successF
   * @param errorF
   * @returns {Promise<void>}
   */
  static async signDocument(documentPath, email, signaturePath, signerName, outputDocumentPathStr, successF, errorF) {

    var params = new URLSearchParams();
    params.append("documentPath",documentPath);    
    params.append("email", email);
    params.append("signaturePath", signaturePath);
    params.append("signerName", signerName);
    params.append("outputDocumentPathStr", outputDocumentPathStr);   

    await WrapperService.get(API_URL + "/signDocument", {params: params}, serviceName, successF, errorF);
  }

  /**
    @param successF
    @param errorF
    @returns true if sproof is enabled
  */
  static async isSproofEnabled(successF, errorF) {
        await WrapperService.get(API_URL + "/sproofEnabled", null, serviceName, successF, errorF);
  }
}  